module.exports = __webpack_public_path__ + "img/echo-viewpoint-1.4ba1ecbb.jpg";